var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.item.isshow)?_c('a-form-item',[_c('a-checkbox',{on:{"change":_vm.onChange}},[_vm._v("\n    "+_vm._s(_vm.item.showname || _vm.item.name)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }